import { useFormContext, useWatch } from "react-hook-form";

import { Paper, Stack, Typography } from "@mui/material";

import { formatMoney } from "../../../shared";
import { useEffect } from "react";

export const PriceSummarySection = () => {
  const { control, setValue } = useFormContext();
  // No `exact` here: the row fields are written per sub-path
  // (purchaseInvoicePayments.0.allocatedAmount / .discountAccounts), and an
  // exact watch ignores those, leaving the summary — and the grandTotal it
  // feeds the payload — stale.
  const purchaseInvoicePayments = useWatch({
    control,
    name: "purchaseInvoicePayments",
  });

  const subtotal =
    purchaseInvoicePayments?.reduce(
      (acc, payment) => acc + (payment.allocatedAmount || 0),
      0
    ) || 0;

  // Discount is derived from the discount accounts attached to each row.
  const totalDiscount =
    purchaseInvoicePayments?.reduce(
      (acc, payment) =>
        acc +
        (payment.discountAccounts ?? []).reduce(
          (rowAcc, account) => rowAcc + (account.amount || 0),
          0
        ),
      0
    ) || 0;

  const grandTotal = subtotal - totalDiscount;

  useEffect(() => {
    setValue("grandTotal", grandTotal);
  }, [grandTotal, setValue]);

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Stack spacing={1}>
        {/* Subtotal Display */}
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          <Typography variant="body2">Subtotal</Typography>
          <Typography variant="body2">{formatMoney(subtotal)}</Typography>
        </Stack>

        {/* Total Discount Display */}
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          <Typography variant="body2">Total Diskon</Typography>
          <Typography variant="body2">{formatMoney(totalDiscount)}</Typography>
        </Stack>

        {/* Grand Total Display */}
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          <Typography sx={{
            fontWeight: "bold"
          }}>Grand Total</Typography>
          <Typography sx={{
            fontWeight: "bold"
          }}>{formatMoney(grandTotal)}</Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};
